/* Text badge with a non-colour shape marker (DESIGN_SYSTEM.md §12). */
.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 0 var(--space-2);
  min-height: 24px;
  border: var(--border-default) solid var(--color-border-default);
  border-radius: var(--radius-round);
  background: var(--color-bg-surface);
  color: var(--color-content-secondary);
  font: var(--type-label);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

.badge[data-tone='attention'] {
  border-style: dashed;
  color: var(--color-content-primary);
}

.badge[data-tone='negative'] {
  border-color: var(--color-negative-emphasis);
  color: var(--color-negative-content);
}

.badge[data-tone='positive'] {
  border-color: var(--color-positive-emphasis);
  color: var(--color-positive-content);
}

/* The non-colour marker: same size in every tone, readable alone. */
.badgeShape {
  font: var(--type-label);
  line-height: 1;
}
